import { render, staticRenderFns } from "./PackagingRequirements.vue?vue&type=template&id=1ab7598c&scoped=true"
import script from "./PackagingRequirements.vue?vue&type=script&lang=js"
export * from "./PackagingRequirements.vue?vue&type=script&lang=js"
import style0 from "./PackagingRequirements.vue?vue&type=style&index=0&id=1ab7598c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab7598c",
  null
  
)

export default component.exports